<template>
    <a-layout style="min-height: 100vh;">
        <UserHead />
        <a-layout>
            <a-layout-header style="padding: 0; background: #fff; border-bottom: 1px solid #f0f0f0;">
                <HeadTop />
            </a-layout-header>
            <a-layout-content class="page-content" style="padding: 24px; background: #f5f7fa;">
                <div class="page-inner">
                    <a-card :bordered="false" class="auth-card">
                        <template #title>
                            <div class="page-title">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke-width="1.8" stroke="#1677ff" width="20" height="20"
                                    style="vertical-align: -3px;">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                <span class="title-text">免费授权</span>
                            </div>
                        </template>

                        <a-form :layout="form_layout" :model="form" class="auth-form">
                            <a-row :gutter="16">
                                <a-col :span="12">
                                    <a-form-item label="插件">
                                        <a-select v-model:value="form.includes_id" placeholder="请选择插件"
                                            @change="selectIncludes">
                                            <a-select-option v-for="item in includes_data" :key="item.id"
                                                :value="item.id">
                                                {{ item.id + ' --- ' + item.name }}
                                            </a-select-option>
                                        </a-select>
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item v-if="form.includes_id" label="功能版本">
                                        <a-select v-model:value="form.version" placeholder="请选择功能版本"
                                            @change="selectVersion" :disabled="version_list.length === 0">
                                            <a-select-option v-for="item in version_list" :key="item.version"
                                                :value="item.version">{{
                                                    item.versionName }}</a-select-option>
                                            <a-select-option v-if="version_list.length === 0 && form.includes_id"
                                                disabled>--该插件无版本信息--</a-select-option>
                                        </a-select>
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="授权域名">
                                        <a-input v-model:value="form.host" placeholder="请输入域名/IP" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="绑定邮箱">
                                        <a-input v-model:value="form.email" placeholder="请输入邮箱" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="推荐人UID">
                                        <a-input v-model:value="form.uid" placeholder="选填" />
                                    </a-form-item>
                                </a-col>
                            </a-row>

                            <a-card class="includes-description" title="授权说明" size="small" style="margin-bottom: 16px;">
                                <div v-if="select_Includes.isWhole == 1">
                                    该插件<strong style="color: #1677ff;">支持泛域名</strong>，请填写一级域名，例如 baidu.com
                                    <span v-if="selected_version.free_day">, 免费时长<strong style="color: #1677ff;">{{
                                        selected_version.free_day }}</strong>天</span>
                                    <span v-else-if="select_Includes.freeDay">, 免费时长<strong style="color: #1677ff;">{{
                                        select_Includes.freeDay }}</strong>天</span>
                                </div>
                                <div v-else-if="select_Includes.isWhole == 0">
                                    该插件<strong style="color: #ff4d4f;">不支持泛域名</strong>，请填写后台域名，例如 www.baidu.com
                                    <span v-if="selected_version.free_day">, 免费时长<strong style="color: #1677ff;">{{
                                        selected_version.free_day }}</strong>天</span>
                                </div>
                                <div v-else>请选择插件</div>
                            </a-card>

                            <a-form-item>
                                <a-button type="primary" class="submit-btn" @click="addAuth">免费授权</a-button>
                            </a-form-item>
                        </a-form>
                    </a-card>
                </div>
            </a-layout-content>
        </a-layout>
    </a-layout>
</template>

<style lang="scss" scoped>
.page-inner {
    max-width: 1200px;
    margin: 0 auto;
}

.page-title {
    display: flex;
    align-items: center;
    gap: 8px;

    .title-text {
        font-size: 16px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.88);
    }
}

.auth-card {
    border-radius: 8px;

    :deep(.ant-card-head) {
        border-bottom: 1px solid #f0f0f0;
        padding: 0 16px;
        min-height: 48px;
    }

    :deep(.ant-card-body) {
        padding: 20px;
    }
}

.auth-form {
    :deep(.ant-form-item-label > label) {
        font-size: 13px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.65);
    }
}

.includes-description {
    border-radius: 8px;

    :deep(.ant-card-head) {
        padding: 12px 14px;
        min-height: 44px;
    }

    :deep(.ant-card-head-title) {
        font-weight: 600;
        font-size: 14px;
    }

    :deep(.ant-card-body) {
        padding: 14px;
        color: #595959;
        font-size: 13px;
        line-height: 1.7;
    }
}

.submit-btn {
    min-width: 160px;
    height: 40px;
}
</style>

<script>
import { defineComponent } from 'vue';
import axios from 'axios';
import { message } from 'ant-design-vue';
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils'
import UserHead from '@/components/UserHead.vue';
import HeadTop from '@/components/UserHeadTop.vue';
const baseURL = process.env.VUE_APP_API_BASE_URL;
export default defineComponent({
    components: {
        UserHead,
        HeadTop
    },
    data() {
        return {
            form: {
                host: "",
                includes_id: "",
                email: "",
                uid: "",
                version: ""
            },
            includes_data: [],
            select_Includes: {},
            selected_version: {},
            version_list: [],
            form_layout: "horizontal",
            bgImageUrl: [
                require('@/assets/img/bg2.webp'),
                require('@/assets/img/bg3.jpg'),
                require('@/assets/img/bg4.png'),
                require('@/assets/img/bg5.png'),
                require('@/assets/img/bg6.webp'),
                require('@/assets/img/bg7.webp'),
                require('@/assets/img/bg8.webp'),
                require('@/assets/img/bg9.webp'),
            ]
        }
    },
    computed: {
        bgStyle() {
            return {};
        }
    },
    methods: {
        addAuth() {
            openLoading()
            const headers = {
                'token': localStorage.getItem("token"),
                'content-type': 'application/json'
            }
            axios.post(baseURL + '/free/addAuth', JSON.stringify(this.form), { timeout: 5000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        message.success(res.data.msg)
                    } else {
                        message.error(res.data.msg)
                    }
                }).catch(err => {
                    message.error(err.message)
                }).finally(() => {
                    fullscreenLoading.close()
                })
        },
        selectIncludes(id) {
            for (let i = 0; i < this.includes_data.length; i++) {
                if (this.includes_data[i].id == id) {
                    this.select_Includes = this.includes_data[i];
                    break;
                }
            }
            this.form.version = "";
            this.version_list = [];
            this.selected_version = {};
            if (id) {
                this.getPluginVersions(id);
            }
        },
        getPluginVersions(soft_id) {
            openLoading();
            const headers = { 'content-type': 'application/json' };
            const data = { soft_id: soft_id };
            axios.post(baseURL + "/userApi/getSoftVersion", data, { timeout: 5000, headers })
                .then(res => {
                    fullscreenLoading.close();
                    if (res.data.code == 200) {
                        this.version_list = res.data.data.list || [];
                        if (this.version_list.length === 1) {
                            this.form.version = this.version_list[0].version;
                            this.selectVersion(this.version_list[0].version);
                        }
                    } else {
                        message.error(res.data.msg || '获取版本信息失败');
                    }
                })
                .catch(err => {
                    fullscreenLoading.close();
                    console.log(err);
                    message.error('获取版本信息失败：' + err.message);
                });
        },
        selectVersion(version) {
            this.selected_version = this.version_list.find(item => item.version === version) || {};
        },
        getIncludes() {
            axios.get(baseURL + '/free/getFreeIncludes', { timeout: 5000 }).then(
                res => {
                    if (res.data.code == 200) {
                        this.includes_data = res.data.data
                    } else {
                        message.error(res.data.msg)
                    }
                }, err => {
                    message.error(err.message)
                }
            )
        },
        setFormLayout() {
            this.form_layout = window.innerWidth < 768 ? "vertical" : "horizontal";
        }
    },
    mounted() {
        this.getIncludes()
        this.setFormLayout()
    }
})
</script>
